import React, { Component } from 'react';
import { Card, Row, Col, InputGroup, FormControl, Modal, Button } from 'react-bootstrap';
import { config } from '../../Constants';
import axios from 'axios';
import global from '../global';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import queryString from 'query-string';
import mainBG from '../../Asset/Images/easy-dividend-bg.png';
import goBack from '../../Asset/Images/previous-icon.png';
import EasyDebenturesLogo from '../../Asset/Images/easy-dividend-logo.png';
import DivPdf from '../../Asset/documents/Data Privacy Policy-BIL.pdf';
import DebenturesHubLogo from '../../Asset/Images/Debentures-Hub-logo.svg';
import NexdmsmImg from '../../Asset/Images/nexdigm-logo-sm.png';

export class FileUpload extends Component {
    static displayName = FileUpload.name;

    constructor(props) {
        super(props);
        this.state = {
            filesToBeSent: [],
            fileTRC: '',
            file10F: '',
            fileNoPE: '',
            fileOD1: '',
            fileOD2: '',
            showDP: 'N',
            isOpen: false,
            isModalOpen: false,
            AssignmentCode: '',
            Email: '',
            isBASF: 'none',
            isChk: 1,
            NR: '',
            ShareholderName: '',
            IsSubmitDisable: false,
            DPID: '',
            PAN: '',
        };

        const parsed = queryString.parse(window.location.search);
        this.state.AssignmentCode = parsed['AN'] == undefined ? "" : window.atob(parsed['AN']);
        this.state.Email = parsed['EM'] == undefined ? "" : window.atob(parsed['EM']);
        this.state.showDP = parsed['DP'] == undefined ? "N" : window.atob(parsed['DP']);
        this.state.NR = parsed['NR'] == undefined ? "" : window.atob(parsed['NR']);
        this.state.ShareholderName = parsed['SN'] == undefined ? "" : window.atob(parsed['SN']);
        this.state.DPID = parsed['DPID'] == undefined ? "" : window.atob(parsed['DPID']);
        this.state.PAN = parsed['PAN'] == undefined ? "" : window.atob(parsed['PAN']);
        if (this.state.showDP == "Y") {
            this.state.isBASF= 'block';
            this.state.isChk = 0;
        }
        else {
            this.state.isBASF = 'none';
            this.state.isChk = 1;
        }
    }


    showNoti(title, message, type) {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });
    };

    closeModal = () => {
        this.setState({ isOpen: false });
        this.setState({ IsSubmitDisable: true });
        window.location.href = config.url.Web_URL + '/';
    };

    closeModalN = () => {
        this.setState({ isModalOpen: false });
    };

    handleCheckBox(e) {
        const checked = e.target.checked;

        if (checked) {
            this.setState({
                isChk: 1
            });
        }
        else {
            this.setState({
                isChk: 0
            });
        }
    }

    handlefileTRC = event => {
        debugger
        let file = event.target.files[0];

        var filesArray = event.target.files[0];   //this.state.filesToBeSent;

        let form = new FormData();
        var mimeType = filesArray.type;

        this.setState({ fileTRC: event.target.files[0] });

        //form.append("File", filesArray);
        //form.append("fileName", filesArray.name);

        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (type == "pdf" || type == "jpg" || type == "png" || type == "doc" || type == "docx" || type == "msg") {
            this.setState({ fileTRC: event.target.files[0] });
        }
        else {
            event.target.value = null;
            this.showNoti("Notification", global.Message.SpecifiedFormatRequiredMessage, "danger");
        }

        if (file.size > 3145728) {
            event.target.value = null;
            this.showNoti("Notification", "Maximum File Size is 3 MB", "danger");
        }

    };

    handlefile10F = event => {
        debugger
        let file = event.target.files[0];
        var filesArray = event.target.files[0];   //this.state.filesToBeSent;

        let form = new FormData();
        var mimeType = filesArray.type;

        this.setState({ file10F: event.target.files[0] });

        form.append("File", filesArray);
        form.append("fileName", filesArray.name);

        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (type == "pdf" || type == "jpg" || type == "png" || type == "doc" || type == "docx" || type == "msg") {
            this.setState({ file10F: event.target.files[0] });
        }
        else {
            event.target.value = null;
            this.showNoti("Notification", global.Message.SpecifiedFormatRequiredMessage, "danger");
        }

        if (file.size > 3145728) {
            event.target.value = null;
            this.showNoti("Notification", "Maximum File Size is 3 MB", "danger");
        }

    };

    handlefileNoPE = event => {
        debugger
        let file = event.target.files[0];

        var filesArray = event.target.files[0];   //this.state.filesToBeSent;

        let form = new FormData();
        var mimeType = filesArray.type;

        this.setState({ fileNoPE: event.target.files[0] });

        //form.append("File", filesArray);
        //form.append("fileName", filesArray.name);

        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (type == "pdf" || type == "jpg" || type == "png" || type == "doc" || type == "docx") {
            this.setState({ fileNoPE: event.target.files[0] });
        }
        else {
            event.target.value = null;
            this.showNoti("Notification", global.Message.SpecifiedFormatRequiredMessage, "danger");
        }

        if (file.size > 3145728) {
            event.target.value = null;
            this.showNoti("Notification", "Maximum File Size is 3 MB", "danger");
        }
    };

    handlefileOD1 = event => {
        debugger
        let file = event.target.files[0];

        var filesArray = event.target.files[0];   //this.state.filesToBeSent;

        let form = new FormData();
        var mimeType = filesArray.type;

        this.setState({ fileOD1: event.target.files[0] });

        //form.append("File", filesArray);
        //form.append("fileName", filesArray.name);

        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (type == "pdf" || type == "jpg" || type == "png" || type == "doc" || type == "docx" || type == "msg") {
            this.setState({ fileOD1: event.target.files[0] });
        }
        else {
            event.target.value = null;
            this.showNoti("Notification", global.Message.SpecifiedFormatRequiredMessage, "danger");
        }

        if (file.size > 3145728) {
            event.target.value = null;
            this.showNoti("Notification", "Maximum File Size is 3 MB", "danger");
        }

    };

    handlefileOD2 = event => {
        debugger
        let file = event.target.files[0];

        var filesArray = event.target.files[0];   //this.state.filesToBeSent;

        let form = new FormData();
        var mimeType = filesArray.type;

        this.setState({ fileOD2: event.target.files[0] });

        //form.append("File", filesArray);
        //form.append("fileName", filesArray.name);

        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (type == "pdf" || type == "jpg" || type == "png" || type == "doc" || type == "docx" || type == "msg") {
            this.setState({ fileOD2: event.target.files[0] });
        }
        else {
            event.target.value = null;
            this.showNoti("Notification", global.Message.SpecifiedFormatRequiredMessage, "danger");
        }

        if (file.size > 3145728) {
            event.target.value = null;
            this.showNoti("Notification", "Maximum File Size is 3 MB", "danger");
        }

    };

    handleAccept = (e) => {
        let form = new FormData();
        
        form.append("FileTRC", this.state.fileTRC);
        form.append("File10F", this.state.file10F);
        form.append("FileNoPE", this.state.fileNoPE);
        form.append("FileOD1", this.state.fileOD1);
        form.append("FileOD2", this.state.fileOD2);
        form.append("Email", this.state.Email);
        form.append("AssignmentCode", this.state.AssignmentCode);
        form.append("NR", this.state.NR);
        form.append("ShareholderName", this.state.ShareholderName);


        axios.post(global.UserManagement.UploadFilesNonResidentAPI, form)
            .then(response => {
                debugger
                if (response.data.status) {
                    this.setState({ isOpen: true, isModalOpen: false });
                }
                else {
                    this.showNoti("Notification", "Unable to Submit Declaration", "danger");
                }
            })
            .catch(error => {
                console.log(error);
            });
       
    }

    handleUpload = (e) => {
        debugger
        let form = new FormData();

        if (this.state.fileTRC == "" || this.state.fileTRC == null) {
            this.showNoti("Notification", "Tax Residency Certificate is required.", "danger");
            return;
        }

        if (this.state.file10F == "" || this.state.file10F == null) {
            this.showNoti("Notification", "Form 10F is required.", "danger");
            return;
        }

        if (this.state.fileNoPE == "" || this.state.fileNoPE == null) {
            this.showNoti("Notification", "No PE Declaration is required.", "danger");
            return;
        }

        if (this.state.showDP == "Y") {
            this.setState({ isModalOpen: true });
            return;
        }
        else {
            form.append("FileTRC", this.state.fileTRC);
            form.append("File10F", this.state.file10F);
            form.append("FileNoPE", this.state.fileNoPE);
            form.append("FileOD1", this.state.fileOD1);
            form.append("FileOD2", this.state.fileOD2);
            form.append("Email", this.state.Email);
            form.append("AssignmentCode", this.state.AssignmentCode);
            form.append("NR", this.state.NR);
            form.append("ShareholderName", this.state.ShareholderName);
            form.append("DPID", this.state.DPID);
            form.append("PAN", this.state.PAN);
            this.setState({ IsSubmitDisable: true });

            axios.post(global.UserManagement.UploadFilesNonResidentAPI, form)
                .then(response => {
                    debugger
                    if (response.data.status) {
                        this.setState({ isOpen: true, isModalOpen: false });
                    }
                    else {
                        this.showNoti("Notification", "Unable to Submit Declaration", "danger");
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

    handleCancel = (e) => {

        e.preventDefault();
        window.location.href = config.url.Web_URL + `/NonResident`;
    }

    render() {
        return (

            <div>
                <ReactNotification />

                <div className="limiter">
                    <div className="container-login100" style={{ backgroundImage: 'url("' + mainBG + '")' }}>
                        <div className="content-page">

                            <div className="wrap-login100 m-t-20">
                                <img src={DebenturesHubLogo} alt="Logo" className="logo-img  m-t-20" />
                                <div className="login100-form">
                                <h3 className="legend last docTitle">Non Resident Documents</h3>
                                <Row className="w-100 dec_form">
                                    <Col md={12}>
                                        <label className="required-field text-bold leftField">Tax Residency Certificate</label>
                                         
                                        <input type="file" name="files" id="fileTRC" onChange={this.handlefileTRC} className="m-t-20" />
                                    </Col>
                                    <Col md={12} className="m-t-10">
                                        <label className="required-field text-bold leftField">Form 10F</label>
                                         
                                        <input type="file" name="files" id="file10F" onChange={this.handlefile10F} className="m-t-20" />
                                    </Col>
                                    <Col md={12} className="m-t-10">
                                        <label className="required-field text-bold leftField">No PE Declaration</label>
                                         
                                        <input type="file" name="files" id="fileNoPE" onChange={this.handlefileNoPE} className="m-t-20" />
                                    </Col>

                                    <Col md={12} className="m-t-10">
                                        <label className="text-bold leftField">Other Document 1</label>
                                        
                                        <input type="file" name="files" id="fileOD1" onChange={this.handlefileOD1} className="m-t-20" />
                                    </Col>

                                    <Col md={12} className="m-t-10">
                                        <label className="text-bold leftField">Other Document 2</label>
                                         
                                        <input type="file" name="files" id="fileOD2" onChange={this.handlefileOD2} className="m-t-20" />
                                    </Col>
                                    <Col md={12} className="m-t-20">
                                        <label className="m-t-10 labelNote">Note: Only .pdf, .doc, .docx, .jpg, .png & .msg file format are allowed and max size is 3 MB</label>
                                    </Col>
                                    <Col md={12} className="m-t-20 labelNote" style={{ display: this.state.isBASF }}>
                                        <input type="checkbox" name="myCheckbox" value={this.state.isChk} onChange={this.handleCheckBox.bind(this)} /> I hereby give my consent for use of these documents/information for carrying out withholding tax compliances by BASF Limited and/or its consultants
                                    </Col>
                                    <Col md={12} className="m-t-20">
                                            <button className="btn btn-primary w-100" onClick={this.handleUpload} disabled={!this.state.isChk} disabled={this.state.IsSubmitDisable}>
                                            Submit Declaration
                                        </button>
                                    </Col>
                                </Row>
                                    <div className="txt1 text-center p-t-20">
                                        <img src={goBack} className="go_back" onClick={this.handleCancel} alt="Go to previous page" title="Go to previous page" />

                                </div>
                                    <div className="txt1 text-center p-t-20" style={{ textAlign: "center" }}>
                                        <span style={{ verticalAlign: "middle" }}>Powered by </span>
                                        <img src={NexdmsmImg} style={{ verticalAlign: "middle" }} />
                                    </div>
                            </div>
                            <Row>
                                <Modal show={this.state.isOpen} onHide={this.closeModal}>
                                    <Modal.Header closeButton>
                                        <Modal.Title className="modal_title">Notification !</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className="modal_body">
                                        Declaration has been submitted successfully
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="dark" onClick={this.closeModal}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                            </Row>

                            </div>
                        </div>
                    </div>
                </div>

                <Modal show={this.state.isModalOpen} onHide={this.closeModalN}>
                    <Modal.Header closeButton>
                        <Modal.Title className="modal_title">Data Privacy Policy</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal_body">
                        <iframe src={DivPdf} height={"350"} width={"100%"} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-primary float-right m-r-10 m-b-10" variant="primary" onClick={this.handleAccept}>
                            I Accept
                        </Button>

                        <Button variant="dark" onClick={this.closeModalN}>
                            Close
                        </Button>

                    </Modal.Footer>
                </Modal>
            </div>
            );
    }
}